import React, { useEffect } from 'react'

const PrepaidMulitplyChangeOptions = [
  {type: "SetSaldo", inputType: "number", label: "Nadpisz kwotę"},
  {type: "AddSaldo", inputType: "number", label: "Dodaj kwotę"},
  {type: "SubtractSaldo", inputType: "number", label: "Odejmij kwotę"},
  {type: "SetStatus", inputType: "select", label: "Ustaw status"},
  {type: "SetGroup", inputType: "select", label: "Ustaw grupę"},
]

export default function PrepaidMulitplyChange({PrepaidMulitplyChange, setPrepaidMulitplyChange, prepaidGroups = [], statuses = [], handleSubmit, selectAll, unselectAll}) {
  useEffect(() => {
    if (!Object.keys(PrepaidMulitplyChange).length) {
      setPrepaidMulitplyChange({});
    }
  }, []);

  return (
    <div className='d-flex flex-wrap justify-content-center w-100 mb-2 border rounded p-2 align-items-center' >
      {PrepaidMulitplyChangeOptions.map((option) => {
        if (option.type === 'SetStatus') {
          return (
            <div key={option.type} className='d-flex flex-column align-items-center m-2'>
              <label>{option.label}</label>
              <select
                className='form-control form-control-sm'
                value={PrepaidMulitplyChange[option.type] || ''}
                onChange={e => setPrepaidMulitplyChange({...PrepaidMulitplyChange, [option.type]: e.target.value})}
              >
                <option value=''>Wybierz status</option>
                {statuses.map(status => (
                  <option key={status.PrepaidStatusId} value={status.PrepaidStatusId}>{status.Name}</option>
                ))}
              </select>
            </div>
          );
        } else if (option.type === 'SetGroup') {
          return (
            <div key={option.type} className='d-flex flex-column align-items-center m-2'>
              <label>{option.label}</label>
              <select
                className='form-control form-control-sm'
                value={PrepaidMulitplyChange[option.type] || ''}
                onChange={e => setPrepaidMulitplyChange({...PrepaidMulitplyChange, [option.type]: e.target.value})}
              >
                <option value=''>Wybierz grupę</option>
                {prepaidGroups.map(group => (
                  <option key={group.PrepaidGroupId} value={group.PrepaidGroupId}>{group.PrepaidGroupName}</option>
                ))}
              </select>
            </div>
          );
        } else {
          return (
            <div key={option.type} className='d-flex flex-column align-items-center m-2'>
              <label>{option.label}</label>
              <input
                type={option.inputType}
                className='form-control form-control-sm'
                value={PrepaidMulitplyChange[option.type] || ''}
                onChange={e => setPrepaidMulitplyChange({...PrepaidMulitplyChange, [option.type]: e.target.value})}
              />
            </div>
          );
        }
      })}
      <div>
        <div  className='d-flex align-items-center m-2 '>
          <button className='btn btn-primary btn-sm' onClick={handleSubmit}>Zatwierdź</button>
        </div>
        <div  className='d-flex align-items-center m-2 '>
          <button className='btn btn-primary btn-sm' onClick={selectAll}>Zaznacz wszystkie</button>
        </div>
        <div  className='d-flex align-items-center m-2 '>
          <button className='btn btn-primary btn-sm' onClick={unselectAll}>Odznacz wszystkie</button>
        </div>
      </div>
    </div>
  );
}
